module.exports = __webpack_public_path__ + "static/media/upload.04e26ae7.svg";